import { render, staticRenderFns } from "./WrongBrowser.vue?vue&type=template&id=bfed5534&scoped=true&"
import script from "./WrongBrowser.vue?vue&type=script&lang=js&"
export * from "./WrongBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfed5534",
  null
  
)

export default component.exports